/*
		event.js,
			Event helpers.
 */

var $ = require('./base.js').$;
var copy = require('./base.js').copy;

if (!window.Event) {
  window.Event = new Object();
}

copy(Event, {
  KEY_BACKSPACE: 8,
  KEY_TAB:       9,
  KEY_RETURN:   13,
  KEY_ESC:      27,
  KEY_PGUP:     33,
  KEY_PGDOWN:   34,
  KEY_LEFT:     37,
  KEY_UP:       38,
  KEY_RIGHT:    39,
  KEY_DOWN:     40,
  KEY_DELETE:   46,

  element: function(event) {
    return event.target || event.srcElement;
  },

  isLeftClick: function(event) {
    return (((event.which) && (event.which == 1)) ||
            ((event.button) && (event.button == 1)));
  },

	stopPropagation: function(evt) {
		if(evt.stopPropagation)
			evt.stopPropagation();
		else
			evt.cancelBubble = true;
	},

  pointerX: function(event) {
    return event.pageX || (event.clientX +
      (document.documentElement.scrollLeft || document.body.scrollLeft));
  },

  pointerY: function(event) {
    return event.pageY || (event.clientY +
      (document.documentElement.scrollTop || document.body.scrollTop));
  },

	mwDelta: function(event) {
		var delta = 0;

		if(event.wheelDelta) {
			/* ie'ish */
			delta = event.wheelDelta / -120;
			if(window.opera)
				delta = -delta;
		}
		else if(event.detail) {
			/* gecko'ish */
			delta = event.detail / 3;
		}

		return delta;		/* +1 = scroll-up, -1 = scroll-down, 0 = unknown */
	},

  stop: function(event) {
    if (event.preventDefault) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.returnValue = false;
      event.cancelBubble = true;
    }
	 return false;
  },

  // find the first node with the given tagName, starting from the
  // node the event was triggered on; traverses the DOM upwards
  findElement: function(event, tagName) {
    var element = Event.element(event);
    while (element.parentNode && (!element.tagName ||
        (element.tagName.toUpperCase() != tagName.toUpperCase())))
      element = element.parentNode;
    return element;
  },

  observers: false,

  _observeAndCache: function(element, name, observer, useCapture) {
    if (!this.observers) this.observers = [];
    if (element.addEventListener) {
      this.observers.push([element, name, observer, useCapture]);
      element.addEventListener(name, observer, useCapture);
    } else if (element.attachEvent) {
      this.observers.push([element, name, observer, useCapture]);
      element.attachEvent('on' + name, observer);
    }
  },

  unloadCache: function() {
    if (!Event.observers) return;
    for (var i = 0; i < Event.observers.length; i++) {
		if(Event.observers[i])
			Event.stopObserving.apply(this, Event.observers[i]);
      Event.observers[i] = null;
    }
    Event.observers = false;
  },

  observe: function(element, name, object, func, useCapture) {
    useCapture = useCapture || false;

    if(name == 'keypress' && (navigator.appVersion.match(/Konqueror|Safari|KHTML/) || element.attachEvent))
      name = 'keydown';

    cb = function(evt) {
	 	evt = evt || window.event;
		return func.call(object, evt);
	 };

    this._observeAndCache(element, name, cb, useCapture);
  },

	unobserveAll: function(element) {
		for(var i = 0; i < Event.observers.length; i++) {
			var entry = Event.observers[i];
			if(entry && entry[0] == element) {
				Event.stopObserving.apply(this, Event.observers[i]);
				Event.observers[i] = null;
			}
		}
	},

  stopObserving: function(element, name, observer, useCapture) {
    var element = $(element);
    useCapture = useCapture || false;

    if(name == 'keypress' && (navigator.appVersion.match(/Konqueror|Safari|KHTML/) || element.detachEvent))
      name = 'keydown';

    if (element.removeEventListener) {
      element.removeEventListener(name, observer, useCapture);
    } else if (element.detachEvent) {
      element.detachEvent('on' + name, observer);
    }
  }
});

/* prevent memory leaks in IE */
Event.observe(window, 'unload', window, Event.unloadCache, false);

module.exports = Event;

